import styled from 'styled-components';

export const StyledEnvLight = styled.div`
    width: 0%;
    height: 0%;
`;